<template>
  <div class="programcommen">
  
    <div class="commenlive">
      <div  class="zhanwei" v-show="commenProgram[0] == 'none' || commenProgram.length=='0' "  >
        <!-- <p>
          <img src="../../assets/noprogram@2x.png" alt="">
        </p> -->
        <p style="margin-top:0.24rem;font-weight:bold;font-size: 0.28rem;">哎呦,一条内容都没有</p>
      </div>
      <div class="live" v-show="commenProgram[0] != 'none'" v-for="(item,index) in commenProgram" :key="index" @click="nextPage(item.number,item.is_live,item.title,item.play_id)">
        <!-- <div class="flex" style="display:flex;"> -->
            <div class="img"  >
            
              <img :src="item.image" alt="" class="programImg"  >
              <div class="liveOrplay">
                    <img  v-if="item.is_live=='1'"  src="../../assets/type1.png" alt=""  class="liveImg1"  >
                    <img v-if="item.is_live=='0'" src="../../assets/type2.png" alt="" class="liveImg">
              </div>
              <div class="isPeriod">
                <p>{{item.period}}期</p>
                 <p>{{item.time}}</p>
              </div>
              <div class="dark"></div>
           
            </div>
            <div class="right">
                <p class="liveName" v-if="item.is_live=='0'">
                  {{item.topic}}
                </p>
                <p class="liveName" v-if="item.is_live=='1'">
                  {{item.topic}}
                </p>
                <p class="liveCaption">
                  <!-- <span class="dian"></span> -->
                  <span class="liveCaption_title">{{item.title}}</span>
                     
                </p>
              
            </div>
            <div class="position">
              <p class="tag">{{item.category_name}}</p>
              <p class="lookNums" v-if="item.is_live == '1'">
                <span>{{item.show_spectators | peopleNumber }}</span>
                <font v-if="item.show_spectators.length>=5">w</font>
                人正在看
              </p>
              <p class="lookNums" v-if="item.is_live == '0'">
                <span>{{item.show_spectators | peopleNumber }}</span>
                <font v-if="item.show_spectators.length>=5">w</font>
                次观看
              </p>
            </div>
      </div> 

    </div>
   
  </div>
</template>

<script>
// let baseurl="http://api.dev.cbct.cn/"
import  {formatDate} from '../../../static/js/date.js'
export default {
  name: 'programcommen',
  props: ["commenProgram"],
  data(){
    return { 
     commenProgramData:'',
     title:'',
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time*1000);
      return formatDate(date, 'yyyy-MM-dd');
    },
    peopleNumber:function(n1){
        if(n1!="") {
           let strNum="";
         if (n1.length>=5) {
           strNum=(parseFloat(n1/10000).toFixed(1))
         }else{
           strNum=n1
         }
          return strNum     
        }
         
     }
  },
  methods:{
    nextPage:function(number,islive,title,play_id){
      // console.log('isLive',islive);
      if (islive=='0') {
        // console.log('回放');
         this.$router.push({
            name:'programRecorded',
            query:{
                 type:'1',
                 live_id:play_id,
                 isLive:islive,
                 title:title
              }
        })
      }else if(islive=='1'){
         this.$router.push({
            name:'programRecorded',
            query:{
                 type:'1',
                 live_id:number,
                 isLive:islive,
                 title:title
              }
          //  path:'programRecorded?type=1&live_id='+number+'&isLive='+islive+'&title='+title
         })
      }
    }
  },

  created(){
    // console.log('commenProgram',this.commenProgram);

  }
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.programcommen{
  width: 6.9rem;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0 0.3rem 0.6rem 0;
} 
.commenlive{
  width: 100%;
  margin-bottom: 0.16rem;
}
.commenlive .live{
  width: 100%;
  /* display: flex;
  align-items: center; */
  margin-bottom: 0.42rem;
  padding-bottom: 0.42rem;
  height: auto;
  overflow: hidden;
  border-bottom: 0.02rem solid rgba(111, 111, 111, 0.1);
  /* border: solid 1px; */

}


.live .img{
  float: left;
  width: 3.16rem;
  height: 1.8rem;
  /* min-width: 2rem; */
  margin: 0;
  position: relative;
  object-fit: cover;
  border-radius: 0.04rem;
}
.live .liveOrplay{
  position: absolute;
  top: 0;
  left: 0;
  width:1.06rem;
  height: .32rem;
  margin: .06rem 0 0 .06rem;
  /* border: solid 1px; */
}
.liveOrplay img{
  position: absolute;
  /* width: 100%;
  height: 100%; */
  top: 0;
  left: 0;
}
.live .isPeriod{
  position: absolute;
  font-size: 0.2rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  bottom: 0.06rem;
  z-index: 100;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 .1rem;
  box-sizing: border-box;
 
}
.live .dark{
  width: 100%;
  position: absolute;
  height: 0.4rem;
  bottom: 0;
  border-radius: 0.1rem;
  background: linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,.5) 100%);
}

.live{
  position: relative;
}
.live .position{
  position: absolute;
  left:3.48rem;
  top: 1.48rem;
  width: 3.42rem;
}
.position .tag{
  float: left;
  width: auto;
  height: 0.28rem;
  border-radius: 0.04rem;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.3);
  font-size: 0.2rem;
  padding: 0 0.1rem;
  padding-top: 0.04rem;
  box-sizing: border-box;
}
.position .lookNums{
  float: right;
  
  padding-top: 0.04rem;
  font-size: 0.2rem;
  color: rgba(0, 0, 0, 0.6);
}
.live .img .programImg{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.show-number{
   position: absolute;
   box-sizing: border-box;
   width: 100%;
   bottom: 0.15rem;
   padding-left: 0.25rem;
   font-size:0.22rem;
   /* font-family:PingFang-SC-Bold; */
   font-weight:bold;
   color:rgba(255,255,255,1);
   text-align: left;

}
.liveImg{
  width:auto;
  height:.32rem;
  margin-right: 0.12rem;
}
.liveImg1{
  width:1.06rem;
  height:.32rem;
  margin-right: 0.12rem;
  vertical-align: middle;
}

.right{
  
  float: left;
  margin-left: 0.3rem;
  /* margin-right: 0.3rem; */
  text-align: left;
  box-sizing: border-box;
}
.liveName{
  max-height: 0.68rem;
  width: 3.44rem;
  box-sizing: border-box;
  font-size:0.28rem;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.85);
  /* color:rgba(252, 64, 74, 1); */
  font-weight:500;
  white-space:wrap;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.liveName2{
  color: rgba(0, 0, 0, 0.85);
}
.liveCaption{
  padding-top: 0.2rem;
  font-size:0.24rem;
  color:rgba(0, 0, 0, 0.5);
  width: 100%;
  width: auto;
  box-sizing: border-box;
  white-space:wrap;
  width: 3.44rem;
}
.liveCaption .dian{
  float: left;
  margin: 0.06rem 0.14rem 0.06rem 0;;
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
  background:rgba(0, 0, 0, 0.3);     
}
.liveCaption .liveCaption_title{
  line-height: 1.3;
}
.liveTime{
  font-size:0.22rem;
  color:rgba(153,153,153,1);
  width: 100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  padding-bottom:0.21rem;
}
.live:last-child{
  border:none;
}
.zhanwei{
  /* width:3.24rem; */
  margin:0 auto;
  /* height: 2.6rem; */
  /* margin-top:1rem; */
  /* background: url('../../assets/noprogram@2x.png'); */
  /* background-size:100%; */
  /* border: solid 1px; */
  
  color: rgba(102,102,102,1);
  font-weight: bold;
}
.zhanwei img{
  width:3.24rem;
}

</style>
